import Vue from 'vue'
import Router from 'vue-router'
import '@/assets/style.css'
import '@/assets/index.css'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home')
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('@/views/case')
    },{
      path: '/caseDetail/:id',
      name: 'caseDetail',
      component: () => import('@/views/case_detail')
    },{
      path: '/team',
      name: 'team',
      component: () => import('@/views/team')
    },{
      path: '/teamDetail/:id',
      name: 'teamDetail',
      component: () => import('@/views/team_detail')
    },{
      path: '/project',
      name: 'project',
      component: () => import('@/views/project')
    },{
      path: '/about',
      name: 'about',
      component: () => import('@/views/about')
    },{
      path: '/news',
      name: 'news',
      component: () => import('@/views/news')
    },{
      path: '/newsDetial/:id',
      name: 'newsDetial',
      component: () => import('@/views/news_detial')
    },{
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/contact')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js